"use strict";

import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';

import { delay } from '../../utils';

import { SearchActions } from '../../actions';
import { SearchStore } from '../../stores';

class QuestionSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      defaultSelected: [],
    };

    this._handleSelection = this._handleSelection.bind(this);
    this._handleTextChange = this._handleTextChange.bind(this);
    this._handleFocus = this._handleFocus.bind(this);
    this._handleSearchStore = this._handleSearchStore.bind(this);
    this._handleCustomChildren = this._handleCustomChildren.bind(this);
  };

  static propTypes = {
    onSelection: React.PropTypes.func,
    value: React.PropTypes.string,
  };

  componentWillMount() {
    const { value } = this.props;
    if(value ) {
      this.setState({ selected: [{title:value}] });
    }

    SearchStore.listen(this._handleSearchStore);
  };

  componentWillReceiveProps(nextProps){
    const { value } = nextProps;
    if(value ) {
      this.setState({ selected: [{title:value}] });
    }
  };

  componentWillUnmount() {
    SearchStore.unlisten(this._handleSearchStore);
  };

  render() {
    const { options, selected } = this.state;
    return(
      <Typeahead ref={ elem => this.typeahead = elem }
                 emptyLabel=''
                 className="search-input search-que"
                 options={ options }
                 labelKey="title"
                 selected={ selected }
                 onChange={ this._handleSelection }
                 onInputChange={ this._handleTextChange }
                 placeholder="Search Questions..."
                 renderMenuItemChildren={ this._handleCustomChildren }
                 onFocus={ this._handleFocus }
      />
    );
  };

  _handleSearchStore(state) {
    if(state._questions) {
      this.setState({ options: state._questions });
    }
  };

  _handleSelection(values) {
    if(values && values.length) {
      this.props.onSelection(values[0]);
      this.setState({ options: [] });
    }
  };

  _handleTextChange(value) {
    if(!this.state.defaultSelected || !this.state.defaultSelected[0]
      || !this.state.defaultSelected[0].title || value !== this.state.defaultSelected[0].title){
      if(typeof this.props.onChange === 'function') this.props.onChange(value);

      delay(() => {
        SearchActions.searchQuestion({ keyword: value });
      }, 500);
    }
  };

  _handleFocus() {
    if(typeof this.props.onFocus === 'function') {
      this.props.onFocus()
    }
  };

  _handleCustomChildren(option) {
    return <strong key="name">{ option.title }</strong>;
  };

  clear() {
    this.typeahead.getInstance().clear();
  };
}

export default QuestionSearch;
